import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RootComponent } from '@core/lib/root.component';
import { BrightnessService } from '@app/services/brightness';
import { toSignal } from '@angular/core/rxjs-interop';
import { ThemeService } from '@app/services/theme';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    RootComponent,
  ],
  host: {
    '[class.tinted]': 'tinting() > 0',
    '[style]': 'styles()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {

  protected readonly tinting = toSignal(inject(BrightnessService).tinting$, { initialValue: 0 });
  protected readonly theme = toSignal(inject(ThemeService).config$);

  protected readonly styles = computed(() => {
    const tinting = this.tinting();
    const theme = this.theme();

    return {
      '--tinting': tinting > 0 ? tinting / 100 : undefined,
      ...ThemeService.styles(theme),
    };
  });

}
